export const INTEGRATE_WOO_COMMERCE =
  'APP/STORES/PLATFORM_COMPONENT/ECOMMERCE/WOO_COMMERCE/INTEGRATE'
export const INTEGRATE_WOO_COMMERCE_SUCCESS =
  'APP/STORES/PLATFORM_COMPONENT/ECOMMERCE/WOOCOMMERCE/INTEGRATE_SUCCESS'
export const INTEGRATE_WOO_COMMERCE_ERROR =
  'APP/STORES/PLATFORM_COMPONENT/ECOMMERCE/WOOCOMMERCE/INTEGRATE_ERROR'
